// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"197":"ed8bb9469385a380","1532":"60e3a477ffa02d63","8757":"17028be61fd4447c"}[chunkId] + ".js";
};